import { render } from "./systems.vue?vue&type=template&id=2bf1d7d9&ts=true"
import script from "./systems.vue?vue&type=script&lang=ts"
export * from "./systems.vue?vue&type=script&lang=ts"

import "./systems.vue?vue&type=style&index=0&id=2bf1d7d9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__